import {
  ADVICE_NAMES,
  AdvicePriceCalculationResult,
  InsuranceAdvice,
} from "Store/advice/interfaces";
import {
  useAdvicePriceCalculationResults,
  useAdviceResult,
} from "./stateSelectors";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { mapInsuranceNameToAdviceCoverageName } from "../utils";

export interface ProductAdviced {
  insuranceAdvice: InsuranceAdvice;
  insurancePrice: AdvicePriceCalculationResult;
}
export interface ProductsAdviced {
  disabilityProductAdviced?: ProductAdviced;
  deathProductAdviced?: ProductAdviced;
  criticalIllnessProductAdviced?: ProductAdviced;
}
export const useAdviceProductsAdviced = (): ProductsAdviced => {
  const adviceResult = useAdviceResult();
  const advicePriceCalculationResults =
    useAdvicePriceCalculationResults() ?? [];

  const getProductAdvicedWithPrice = (
    insuranceProduct: ADVICE_NAMES,
  ): ProductAdviced | undefined => {
    const insuranceAdvice = adviceResult?.advice[insuranceProduct];
    const insurancePrice = advicePriceCalculationResults.find(
      (price) =>
        price.configurationName ===
        mapInsuranceNameToAdviceCoverageName(insuranceProduct),
    );
    return insuranceAdvice && insurancePrice
      ? { insuranceAdvice, insurancePrice }
      : undefined;
  };

  const disabilityProductAdviced = getProductAdvicedWithPrice(
    INSURANCE_NAME_VALUE.DISABILITY_FLEX,
  );
  const deathProductAdviced = getProductAdvicedWithPrice(
    INSURANCE_NAME_VALUE.DEATH,
  );
  const criticalIllnessProductAdviced = getProductAdvicedWithPrice(
    INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
  );

  return {
    disabilityProductAdviced,
    deathProductAdviced,
    criticalIllnessProductAdviced,
  };
};
